import { render } from "./QuestionDefaultValue.vue?vue&type=template&id=605c3ebd"
import script from "./QuestionDefaultValue.vue?vue&type=script&lang=js"
export * from "./QuestionDefaultValue.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__